const zohoChatSelectors = ['#zsiq_float', '.zsiq_floatmain', '#zsiq_agtpic', '.zsiq_flt_rel']
const zohoChatHiddenBodyClass = 'checkout-hide-zoho-chat'
const zohoChatStyleId = 'checkout-zoho-chat-visibility'
let activeHideRequests = 0

const ensureZohoChatVisibilityStyles = () => {
  if (typeof document === 'undefined' || document.getElementById(zohoChatStyleId)) {
    return
  }

  const style = document.createElement('style')
  style.id = zohoChatStyleId
  style.textContent = `
    body.${zohoChatHiddenBodyClass} #zsiq_float,
    body.${zohoChatHiddenBodyClass} .zsiq_floatmain,
    body.${zohoChatHiddenBodyClass} #zsiq_agtpic,
    body.${zohoChatHiddenBodyClass} .zsiq_flt_rel {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `

  document.head.appendChild(style)
}

const setZohoChatBodyVisibility = (visible) => {
  if (typeof document === 'undefined' || !document.body) {
    return
  }

  ensureZohoChatVisibilityStyles()
  document.body.classList.toggle(zohoChatHiddenBodyClass, !visible)
}

const setZohoChatDomVisibility = (visible) => {
  if (typeof document === 'undefined') {
    return
  }

  zohoChatSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (!element.dataset) {
        return
      }

      if (!visible) {
        if (!element.dataset.checkoutPreviousDisplay) {
          element.dataset.checkoutPreviousDisplay = element.style.display || ' '
        }
        element.style.display = 'none'
        return
      }

      if (element.dataset.checkoutPreviousDisplay) {
        element.style.display = element.dataset.checkoutPreviousDisplay === ' '
          ? ''
          : element.dataset.checkoutPreviousDisplay
        delete element.dataset.checkoutPreviousDisplay
      }
    })
  })
}

export const createZohoChatVisibilityController = () => {
  let hiddenByController = false

  const hideChat = () => {
    const floatWindow = window.$zoho?.salesiq?.floatwindow

    if (typeof floatWindow?.visible === 'function') {
      floatWindow.visible('hide')
    }

    setZohoChatBodyVisibility(false)
    setZohoChatDomVisibility(false)
  }

  const showChat = () => {
    const floatWindow = window.$zoho?.salesiq?.floatwindow

    if (typeof floatWindow?.visible === 'function') {
      // Keep this as hide because we want to hide the chat window but make the icon reappear.
      floatWindow.visible('hide')
    }

    setZohoChatBodyVisibility(true)
    setZohoChatDomVisibility(true)
  }

  const setVisibility = (visible) => {
    if (typeof window === 'undefined') {
      return
    }

    if (!visible) {
      if (!hiddenByController) {
        activeHideRequests += 1
        hiddenByController = true
      }

      hideChat()
      return
    }

    if (!hiddenByController) {
      return
    }

    hiddenByController = false
    activeHideRequests = Math.max(0, activeHideRequests - 1)

    if (activeHideRequests > 0) {
      hideChat()
      return
    }

    showChat()
  }

  return {
    setVisibility,
  }
}
